<template>
  <div class="input-field">
    <label :for="name" v-bind:class="{ active: !!value }">{{ label }}</label>
    <input :name="name" :id="name" :type="type" :value="value" @input="change" :class="{ 'invalid': !!errors }"
           :required="required" :pattern="pattern" >
    <error-message :errors="errors" />
  </div>
</template>

<script>
import ErrorMessage from '@/components/forms/errorMessage'
export default {
  components: { ErrorMessage },
  props: ['type', 'name', 'label', 'value', 'errors', 'required', 'pattern'],
  methods: {
    change (e) {
      this.$emit('input', e.target.value)
      this.$emit('updateError')
    }
  }
}
</script>

<style lang="scss" src="./input.scss"></style>



// WEBPACK FOOTER //
// text.vue?59a90195